import * as React from "react"
import { View, ViewStyle, Platform } from "react-native"
import { observer } from "mobx-react-lite"
import { color } from "../../theme"
import { Text } from "../text/text"
import { JalaIcon } from "../jala-icon/jala-icon"
import { TxKeyPath } from "../../i18n"
import { TouchableOpacity } from "react-native-gesture-handler"

const CONTAINER: ViewStyle = {
  // height: 50,
  backgroundColor: color.primary,
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
}

const SECTION: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center',
}

const ICON: ViewStyle = {
  padding: 16
}

export interface CustomHeaderProps {
  /**
   * An optional style override useful for padding & margin.
   */
   needBackButton?: boolean,
   title?: TxKeyPath,
   label?: string,
   rightIcon1?: string,
   rightIcon2?: string,
   rightIcon3?: string,
   onPressBack?: () => void,
   onPressRight1?: () => void,
   onPressRight2?: () => void,
   onPressRight3?: () => void
}

/**
 * Describe your component here
 */
export const CustomHeader = observer(function CustomHeader(props: CustomHeaderProps) {
  const { needBackButton, label, title, rightIcon1, rightIcon2, rightIcon3, onPressBack, onPressRight1 } = props

  const icon = (onPress, icon, size) => {
    return (
      <TouchableOpacity onPress={onPress} style={ICON}>
        <JalaIcon name={icon} size={size} color={color.palette.white} />
      </TouchableOpacity>
    )
  }

  const isIos = Platform.OS === 'ios';
  const backIcon = isIos ? 'arrow_back_ios' : 'arrow_back'
  return (
    <View style={CONTAINER}>
      <View style={SECTION}>
        {needBackButton && icon(onPressBack, backIcon, 20)}
        <Text preset="title2" color={color.palette.white} text={label} tx={title} />
      </View>
      <View style={SECTION}>
        {rightIcon1 && icon(onPressRight1, rightIcon1, 22)}
        {rightIcon2 && icon(onPressRight1, rightIcon2, 22)}
        {rightIcon3 && icon(onPressRight1, rightIcon3, 22)}
      </View>
    </View>
  )
})
